import React from "react";
import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <Box
      sx={{
        mt: 6,
        py: 4,
        textAlign: "center",
        backgroundColor: "#000",
        color: "white",
      }}
    >
      <Typography variant="body2">
        &copy; {new Date().getFullYear()} Jasel. All rights reserved. |{" "}
        <Link to="/terms" style={{ textDecoration: "none", color: "#1976d2" }}>
          Terms & Conditions
        </Link>{" "}
        |{" "}
        <Link to="/privacy" style={{ textDecoration: "none", color: "#1976d2" }}>
          Privacy Policy
        </Link>
      </Typography>
    </Box>
  );
};

export default Footer;
